<mat-slider
  [min]="min()"
  [max]="max()"
  [step]="step()"
  [displayWith]="format"
  discrete
>
  <input
    matSliderStartThumb
    (dragEnd)="dragEnd($event)"
    [formControl]="minFormControl()"
    [attr.aria-label]="minAriaLabel()"
  />
  <input
    matSliderEndThumb
    (dragEnd)="dragEnd($event)"
    [formControl]="maxFormControl()"
    [attr.aria-label]="maxAriaLabel()"
  />
  <div class="slider__label-container">
    <div class="slider__label-min">
      {{ format(minFormControl().value ?? min()) }}
    </div>
    <div class="slider__label-max">
      {{ format(maxFormControl().value ?? max()) }}
      @if (
        !valueFormatter() &&
        (maxFormControl().value === max() || !maxFormControl().value)
      ) {
        +
      }
    </div>
  </div>
</mat-slider>
